/**
 * Immutable semantic presentation for one Date value.
 */
export type DateReadContent = {
  readonly kind: 'date';
  readonly text: string;
};

export const EMPTY_DATE_CONTENT: DateReadContent = Object.freeze({
  kind: 'date',
  text: ''
});
